
import DialogTemplate from '@/views/DialogTemplate.vue'
import Pic from 'common/Pic.vue'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ThePostConfirmDialog',
  components: { Pic, DialogTemplate },
})
